import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const useStyles = makeStyles({
  root: {
    width: '100%',
    marginTop:'-50px',
    marginBottom:'50px'
  },
});

export default function ProgressBar(props) {
  const classes = useStyles();
  const a =  (parseInt(props.step)/17)*100
  const [progress, setProgress] = React.useState(0);
  useEffect(()=>{
    setProgress(a)
  },[a])
  return (
    <>
     <div className={classes.root} >
      <LinearProgress variant="determinate" value={progress} />
    </div>
    </>
  );
}
